import React, { forwardRef } from 'react';

export const Input = forwardRef(function Input(
  { className = '', type = 'text', ...props },
  ref
) {
  return (
    <input
      ref={ref}
      type={type}
      className={`block w-full rounded-md border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 px-3 py-2 text-gray-700 dark:text-gray-200 shadow-sm hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-gray-800 focus:ring-gray-400 dark:focus:ring-gray-500 focus:ring-opacity-50 transition-colors duration-150 ease-in-out text-base sm:text-sm ${className}`}
      {...props}
    />
  );
});

export default Input; 